import { Component, DoCheck, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, interval, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { getDashboardsConfigState, State } from 'src/app/dashboards/state';
import { deepCheckObject, register } from 'src/app/dashboards/widget/widget-helpers/helpers';
import { AppEventType, widgetType } from 'src/app/enums';
import { gridItem } from 'src/app/models';
import { DashboardService } from 'src/app/services/services/dashboard.service';
import { WidgetBaseComponent } from '../../widget-base.component';
import { I18NextPipe } from 'angular-i18next';
import { MatSort } from '@angular/material/sort';
import { EventQueueService } from 'src/app/services/services/EventQueueService';

@Component({
    selector: 'app-agents',
    templateUrl: './agents.component.html',
    styleUrls: ['./agents.component.scss'],
    standalone: false
})
@register("Agents")
export class AgentsComponent implements OnInit, OnDestroy, WidgetBaseComponent {
  @Input() public isInWizard: boolean;
  @Output() public restrictedDataEvent = new EventEmitter<boolean>();

  restrictedData: boolean = false;
  isDataFilteredByLoggedIn: boolean = false;

  _gridItem: gridItem;
  get gridItem(): gridItem {
    return this._gridItem;
  }
  @Input() set gridItem(value: any) {
    this._gridItem = value;
    setTimeout(() => {
      this.notifier.next();
    }, 0);
  }

  _dataEquality: boolean;
  get dataEquality(): boolean {
    return this._dataEquality;
  }
  @Input() set dataEquality(value: boolean) {
    this._dataEquality = value;
    if (!value) {
      this.getData();
    }
  }

  _colorSchemeId: number;
  get colorSchemeId(): number {
    return this._colorSchemeId;
  }
  @Input() set colorSchemeId(value: number) {
    this._colorSchemeId = value;
  }

  public data: any[];
  public propsWithIds: any[];

  public agents$: Observable<any[]>;
  public terminate$ = new Subject<void>();
  public notifier: Subject<void> = new Subject<void>();

  public type: string = "Agent";

  public widgetType = widgetType;

  constructor(private DashboardsService: DashboardService, private store: Store<State>, private i18nextPipe: I18NextPipe) { }

  ngOnInit(): void {
    this.getData();
    if (!this.isInWizard) {
      this.store.select(getDashboardsConfigState).pipe(take(1)).subscribe(config => {
        interval(config.widgetRefreshInterval.realTime * 1000).pipe(takeUntil(this.terminate$)).subscribe(_ => { this.getData(); });
      });
    }
  }

  ngOnDestroy(): void {
    this.terminate$.next();
    this.terminate$.complete();
  }

  getData(): void {
    if (this.gridItem.setup.agentIds != undefined && this.gridItem.setup.agentPropertiesIds != undefined) {
      if (this.gridItem.setup.agentIds.length > 0 && this.gridItem.setup.agentPropertiesIds.length > 0) {
        this.agents$ = this.DashboardsService.getAgentData(this.gridItem.setup.agentIds || [], this.gridItem.setup.agentPropertiesIds || []);
        this.agents$.subscribe((d) => {
          this.restrictedDataEvent.emit(d.length > 0 && d.length != this.gridItem.setup.agentIds.length);
          this.isDataFilteredByLoggedIn = this.gridItem.setup.onlyLoggedAgents && d.filter(a => a.LoggedIn).length == 0;
          let data = this.gridItem.setup.onlyLoggedAgents ? d.filter(a => a.LoggedIn) || [] : d;
          data = data.map(a => { delete a.LoggedIn; return a; });
          this.data = data;
          let propsWithIds = [];
          if (data && data.length > 0) {
            let propsKeys = Object.keys(data[0]);
            propsKeys = propsKeys.filter(function (value, index, arr) {
              return value.toLowerCase() !== "id" && value.toLowerCase() !== "name" && value.toLocaleLowerCase() !== "alarmflag";
            });
            for (let i = 0; i < this.gridItem.setup.agentPropertiesIds.length; i++) {
              propsWithIds.push({
                prop: propsKeys[i],
                id: this.gridItem.setup.agentPropertiesIds[i]
              });
            }
            this.propsWithIds = propsWithIds;
          }
          this.notifier.next();
          this.restrictedData = d.length == 0;
        });
      }
    }
  }
}